<template>
    <v-container fluid v-editable="blok" fill-height class="bg" :style="`background-image: url('${blok.background}')`">
        <v-row align-content="center" justify="center">
            <v-col cols="12" align="center" justify="center">
                <p><em>Bienvenido / Welcome</em></p>
                <figure>
                    <img :src="blok.logo" :alt="blok.logo" class="logo">
                </figure>
                <p class="mb-5">Selecciona tu lenguaje / Select your lenguage</p>
                <div class="btn">
                    <v-btn color="secondary" to="/es" class="mr-3 pb" light tile depressed large>Español</v-btn>
                    <v-btn color="accent" class="pb" to="/en"  tile depressed  large>English</v-btn>
                </div>
            </v-col>
        </v-row>
        <div class="low-footer">
            
            <p>PérezBrown</p>
            
            <div>
            <v-btn text dark tile x-small to="/es/legal/privacy">Política de privacidad</v-btn>
            <v-btn text dark tile x-small to="/es/legal/attorney">Attorney advertising</v-btn>
            </div>
        </div>
    </v-container>
</template>

<script>
export default {
  props: ['blok']
}
</script>

<style lang="scss" scoped>
@import "./Hero.scss";
</style>
